module.exports = __webpack_public_path__ + "img/logo-bei.956a8a08.png";